import {
  FirstTimePickupStep,
  FirstTimePickupStepValues,
  LocalDeliveryStep,
  LocalDeliveryStepValues,
  LocalPickupStep,
  LocalPickupStepValues,
  Order,
} from "src/services/order/order.interface";
import { PendingOrder } from "src/services/pending-order/pending-order.interface";
import { ServiceType } from "src/services/subscription/plan-service-type.enum";
import { AnyOrderStep } from "src/services/order-status/order-step.type";

export function getNextStep(order: Order | PendingOrder | undefined): string | undefined {
  if (!order) {
    return;
  }

  let step: string;
  switch (order.serviceType) {
    case ServiceType.firstTimePickup:
      step = order.nextFirstTimePickupStep ?? FirstTimePickupStepValues.reviewOrder;
      break;
    case ServiceType.localDelivery:
      step = order.nextLocalDeliveryStep ?? LocalDeliveryStepValues.reviewOrder;
      break;
    case ServiceType.localPickup:
      step = order.nextLocalPickupStep ?? LocalPickupStepValues.reviewOrder;
      break;
    default:
      step = LocalPickupStepValues.reviewOrder;
  }

  return step;
}

export function firstTimePickupStepIsFurtherThan(
  order: Order | PendingOrder,
  comparedTo: FirstTimePickupStep,
): boolean {
  if (!order?.nextFirstTimePickupStep) {
    return false;
  }
  const stepIndex = Object.keys(FirstTimePickupStepValues).findIndex((key) => key === order.nextFirstTimePickupStep);
  const comparedToIndex = Object.keys(FirstTimePickupStepValues).findIndex((key) => key === comparedTo);

  return stepIndex > comparedToIndex;
}

export function localPickupStepIsFurtherThan(order: Order | PendingOrder, comparedTo: LocalPickupStep): boolean {
  if (!order?.nextLocalPickupStep) {
    return false;
  }
  const stepIndex = Object.keys(LocalPickupStepValues).findIndex((key) => key === order.nextLocalPickupStep);
  const comparedToIndex = Object.keys(LocalPickupStepValues).findIndex((key) => key === comparedTo);

  return stepIndex > comparedToIndex;
}

export function localDeliveryStepIsFurtherThan(order: Order | PendingOrder, comparedTo: LocalDeliveryStep): boolean {
  if (!order?.nextLocalDeliveryStep) {
    return false;
  }
  const stepIndex = Object.keys(LocalDeliveryStepValues).findIndex((key) => key === order.nextLocalDeliveryStep);
  const comparedToIndex = Object.keys(LocalDeliveryStepValues).findIndex((key) => key === comparedTo);

  return stepIndex > comparedToIndex;
}

export function orderStepIsFurtherThan(order: Order | PendingOrder, comparedTo: AnyOrderStep): boolean {
  return (
    firstTimePickupStepIsFurtherThan(order, comparedTo as FirstTimePickupStep) ||
    localPickupStepIsFurtherThan(order, comparedTo as LocalPickupStep) ||
    localDeliveryStepIsFurtherThan(order, comparedTo as LocalDeliveryStep)
  );
}
